/* eslint-disable */

export const stopAllBotsDepthConstants = {
    STOP_ALL_DEPTH_REQUEST: 'STOP_ALL_DEPTH_REQUEST',
    STOP_ALL_DEPTH_SUCCESS: 'STOP_ALL_DEPTH_SUCCESS',
    STOP_ALL_DEPTH_FAILURE: 'STOP_ALL_DEPTH_FAILURE',
};
